import { Component, Injector, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { LoginType } from 'src/app/shared/enums/login-type';
import { ParameterClass } from 'src/app/shared/helpers/helper.service';
import { Nationalities } from 'src/app/shared/models/nationalities';
import { LoginData, ResetPassword, User, UserData } from 'src/app/shared/models/user';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { environment } from 'src/environments/environment.development';
declare var require: any
const Swal = require('sweetalert2')

declare const bootstrap: any; // Needed to use Bootstrap JS modal
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends AppComponentBase implements OnInit {

  basicUrl: string = environment.basicUrl
  staffUrl = environment.staffUrl
  parentUrL = environment.parentUrl
  teacherUrl = environment.teacherUrl
  studentUrl = environment.studentUrl
  dmUrl = environment.dmUrl
  sponsorUrl = environment.sponsorUrl

  loginType = LoginType
  phone: string = '';
  otp: string = '';
  phoneError: string = '';
  otpError: string = '';
  public newUser = false;
  // public user: firebase.User;
  public loginForm!: FormGroup;
  public registerForm!: FormGroup;
  public show: boolean = false
  public errorMessage: any;
  formValues!: LoginData
  registerFormValues!: UserData
  nationalities: Nationalities[] = []
  users!: any[]

  isLogin: boolean = true
  isReset: boolean = false
  isRegister: boolean = false
  isFastRegister: boolean = false

  listOfErrors: any[] = []

  public resetPasswordForm!: FormGroup;
  public fastRegisterForm!: FormGroup;

  codeFirstDigit!: string
  codeSecondDigit!: string
  codeThirdDigit!: string
  codeFourthDigit!: string

  codeSent: boolean = false
  codeVerified: boolean = false

  resetPasswordFormValues!: ResetPassword
  fastRegisterFormValues!: ResetPassword

  acceptTermsAndConditions: boolean = false

  isEmptyNationality: boolean = true

  searchWith: string = 'email'

  public selectedLanguage: any = {
    language: localStorage.getItem('language') ? JSON.parse(localStorage.getItem('language')!).language : 'Arabic',
    code: localStorage.getItem('language') ? JSON.parse(localStorage.getItem('language')!).code : 'ar',
    type: localStorage.getItem('language') ? JSON.parse(localStorage.getItem('language')!).type : 'AR',
    icon: localStorage.getItem('language') ? JSON.parse(localStorage.getItem('language')!).icon : 'eg'
  }

  public layoutType: string = "ltr";

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: 'us'
    },
    {
      language: 'Arabic',
      code: 'ar',
      icon: 'sa'
    },
  ]

  userType: 'teacher' | 'student' | 'sponsor' | 'parent' | 'staff' = 'parent';
  
  constructor(
    injector: Injector,
    private fb: FormBuilder,
    public translate: TranslateService,
    public router: Router,
    private userServices: UsersService,
    private loginService: LoginService,
    private toastr: ToastrService,
    public layout: LayoutService,
    private route: ActivatedRoute,
    private sharedService: SharedService
  ) {
    super(injector)
    this.route.queryParams.subscribe((params) => {
      this.layout.config.settings.layout = params['layout'] ? params['layout'] : this.layout.config.settings.layout
    })
  }

  ngOnInit() {
    this.createForm()

    if (this.route.snapshot.routeConfig?.path?.includes('back-from-conditions')) {
      this.isRegister = true
      this.isLogin = false
      this.isReset = false

      this.createRegisterForm()
      this.getNationalities()
    }
  }

  getUsers() {
    let params: ParameterClass[] = [
      new ParameterClass('paginate', 'false'),
      new ParameterClass('with[]', 'admin'),
      new ParameterClass('with[]', 'guardian'),
    ];
    this.userServices.getUsers(params).subscribe((users: any) => {
      this.users = users.data
    })
  }

  getNationalities() {
    this.sharedService.getRegistrationNationalities().subscribe((nationalities: any) => {
      this.nationalities = nationalities.data
      console.log(nationalities);

    })
  }

  changeLogin(login: boolean) {
    this.isLogin = login
    this.isReset = false
    if (!login) {
      this.createRegisterForm()
      this.getNationalities()
      // this.getUsers()
      this.isRegister = true
    }
    if (login) {
      this.createForm()
      this.isRegister = false
    }
  }

  changeRegister(register: boolean) {
    if (!register) {
      this.isFastRegister = false
      this.isLogin = true
    }
    if (register) {
      this.isFastRegister = true
      this.createResetPasswordForm()
      this.isLogin = false
    }
  }

  openPhoneModal() {
    const modal = new bootstrap.Modal(document.getElementById('phoneModal'));
    modal.show();
  }

  submitPhone() {
    this.phoneError = '';
    if (!this.phone) {
      this.phoneError = 'You need to enter a phone number';
      return;
    }
    if (!/^\+?\d{9}$/.test(this.phone)) {
      this.phoneError = 'رقم الهاتف يجب ان يكون 9 ارقام ويبدأ بالرقم 5';
      return;
    }

    console.log('Sending OTP to:', this.phone);
    this.codeSent = true
    this.loginService.sendOTP(this.phone, 'registration').subscribe((res: any) => {
      this._toastr.success('تم ارسال رقم ال OTP الي رقم الهاتف')
      // Close phone modal
      bootstrap.Modal.getInstance(document.getElementById('phoneModal')).hide();

      // Open OTP modal
      const otpModal = new bootstrap.Modal(document.getElementById('otpModal'));
      otpModal.show();
    }, err => {
      this.showErrors(err)
    })
  }

  submitOTP() {
    this.otpError = '';
    this.otp = this.codeFirstDigit + this.codeSecondDigit + this.codeThirdDigit + this.codeFourthDigit

    if (!this.otp) {
      this.otpError = 'You need to enter the OTP';
      return;
    }
    if (!/^\d{4}$/.test(this.otp)) {
      this.otpError = 'OTP must be 4 digits';
      return;
    }

    let model = {
      phone: this.phone,
      otp_code: this.otp,
      type: 'registration'
    }

    this.loginService.verifyOTP(model).subscribe((res: any) => {
      this._toastr.success('تم التحقق من رقم ال OTP')
      bootstrap.Modal.getInstance(document.getElementById('otpModal')).hide();
      this.changeLogin(false)
    }, err => {
      this.showErrors(err)
    })
  }

  changeResetPasswordForm() {
    this.isReset = true
    this.createResetPasswordForm()
  }

  changeLanguage(lang: any) {
    console.log(this.languages);

    this.translate.use(lang)
    this.selectedLanguage = lang;
    localStorage.setItem('currentLang', lang);
    if (lang == 'ar') localStorage.setItem('language', JSON.stringify(this.languages[1]));
    if (lang == 'en') localStorage.setItem('language', JSON.stringify(this.languages[0]));
    // window.location.reload()
  }

  customizeLayoutType(val: any) {
    this.layoutType = val;
    this.layout.config.settings.layout_type = val;
    if (val == "rtl") {
      document.getElementsByTagName("html")[0].setAttribute("dir", val);
      document.body.className = "rtl";
    } else if (val == "box-layout") {
      document.getElementsByTagName("html")[0].setAttribute("dir", val);
      document.body.className = "box-layout";
    } else {
      document.getElementsByTagName("html")[0].removeAttribute("dir");
      document.body.className = "";
    }
  }

  createForm() {
    this.loginForm = this.fb.group({
      user_name: ["", [Validators.required]],
      password: ["", Validators.required]
    });
  }

  get f() {
    return this.loginForm.controls
  }

  createRegisterForm() {
    this.registerForm = this.fb.group({
      full_name: ["", [Validators.required]],
      full_name_latin: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      phone: ["", [Validators.required, Validators.minLength(9), Validators.maxLength(9)]], //<------ uncomment
      country_id: ["", [Validators.required]],
      password: ["", Validators.required],
      password_confirmation: ["", Validators.required],
      national_id: [{ value: '', disabled: true }, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      address: ["", Validators.required],
      residential_area: [""],
      work_place: [""],
      job_title: [""],
      accept_terms_flag: ["", Validators.required]
    });
  }

  get rF() {
    return this.registerForm.controls
  }

  getIndexOfError(id: any) {
    return this.listOfErrors.findIndex(item => item.id == id)
  }

  pushToErrorList(item: any) {
    if (this.getIndexOfError(item.id) == -1) {
      this.listOfErrors.push(item)
    }
  }

  removeFromErrorList(id: any) {
    if (this.getIndexOfError(id) != -1) {
      this.listOfErrors.splice(this.getIndexOfError(id), 1)
    }
  }

  validateForm() {
    const emailRegex: any = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]{2,}$/;
    // const emailRegex: any = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    console.log(this.formValues.user_name);
    console.log(emailRegex.test(this.formValues.user_name));


    if (!this.formValues.user_name || !this.formValues.password) {
      let item = { id: 1, message: 'تأكد من جميع البيانات المطلوبة' }
      this.pushToErrorList(item)
    } else {
      this.removeFromErrorList(1)
    }

    if (!emailRegex.test(this.formValues.user_name)) {
      if (isNaN(Number(this.formValues.user_name))) {
        let item = { id: 2, message: 'البريد الالكتروني أو رقم الهاتف غير صحيح' }
        this.pushToErrorList(item)
      } else if (this.formValues.user_name.length != 9) {
        let item = { id: 2, message: 'رقم الهاتف غير صحيح' }
        this.pushToErrorList(item)
      } else {
        this.removeFromErrorList(2)
      }
    } else {
      this.removeFromErrorList(2)
    }

    if (this.loginForm.invalid) {
      let item = { id: 3, message: 'هناك خطأ ما,, تأكد من جميع البيانات' }
      this.pushToErrorList(item)
    } else {
      this.removeFromErrorList(3)
    }

    if (this.listOfErrors.length > 0) {
      this.formValid = false
    } else {
      this.formValid = true
    }

    return this.formValid
  }

  validateRegisterForm() {
    // let emailIndex: any;
    // emailIndex = this.users.findIndex(obj => {
    //   return obj.email === this.registerFormValues.email
    // });

    // let phoneIndex
    // phoneIndex = this.users.findIndex(obj => {
    //   return obj.phone === this.registerFormValues.phone
    // });

    // let nationalIdIndex
    // nationalIdIndex = this.users.findIndex(obj => {
    //   return obj.national_id === this.registerFormValues?.national_id
    // });


    if (
      !this.registerFormValues.full_name ||
      !this.registerFormValues.full_name_latin ||
      !this.registerFormValues.email ||
      !this.registerFormValues.phone ||
      !this.registerFormValues.country_id ||
      !this.registerFormValues.password ||
      !this.registerFormValues.password_confirmation ||
      !this.registerFormValues.national_id ||
      !this.registerFormValues.address ||
      !this.registerFormValues.accept_terms_flag
    ) {
      let item = { id: 1, message: 'تأكد من جميع البيانات المطلوبة' }
      this.pushToErrorList(item)
    } else {
      this.removeFromErrorList(1)
    }

    // if (emailIndex != -1) {
    //   let item = {id: 2, message: 'هذا الايميل موجود مسبقا'}
    //   this.pushToErrorList(item)
    // } else {
    //   this.removeFromErrorList(2)
    // }

    // if (phoneIndex != -1) {
    //   let item = {id: 3, message: 'رقم الهاتف موجود مسبقا'}
    //   this.pushToErrorList(item)
    // } else {
    //   this.removeFromErrorList(3)
    // }

    // if (nationalIdIndex != -1) {
    //   let item = {id: 4, message: 'رقم الهوية موجود مسبقا'}
    //   this.pushToErrorList(item)
    // } else {
    //   this.removeFromErrorList(4)
    // }

    if (this.registerFormValues.password && this.registerFormValues.password.length < 8) {
      let item = { id: 5, message: 'كلمة المرور اقل من 8 عناصر' }
      this.pushToErrorList(item)
    } else {
      this.removeFromErrorList(5)
    }

    if (this.registerFormValues.password !== this.registerFormValues.password_confirmation) {
      let item = { id: 6, message: 'كلمة المرور غير متطابقة' }
      this.pushToErrorList(item)
    } else {
      this.removeFromErrorList(6)
    }

    if (this.registerFormValues.phone.length < 9) {
      let item = { id: 7, message: 'الهاتف أقل من 9 أرقام' }
      this.pushToErrorList(item)
    } else {
      this.removeFromErrorList(7)
    } //<-------- uncommented

    if (this.registerFormValues.national_id.length < 10) {
      let item = { id: 8, message: 'رقم الهوية أقل من 10 أرقام' }
      this.pushToErrorList(item)
    } else {
      this.removeFromErrorList(8)
    }

    if (!this.acceptTermsAndConditions) {
      let item = { id: 9, message: 'برجاء الإطلاع علي الشروط و الأحكام و المةافقة عليها' }
      this.pushToErrorList(item)
    } else {
      this.removeFromErrorList(9)
    }

    if (this.listOfErrors.length > 0) {
      this.formValid = false
    } else {
      this.formValid = true
    }

    return this.formValid
  }

  createFormData(values: any) {
    let formData = new FormData();
    Object.entries(values).forEach(([key, value]: any) => {
      formData.append(key, value);
    })

    return formData
  }

  login() {
    this.formSubmitted = true
    this.formValues = this.loginForm.value as LoginData

    console.log(this.loginForm);


    if (this.validateForm()) {

      let userModelToSend = {
        login_type: this.loginType.GUARDIAN,
        user_name: this.formValues.user_name,
        password: this.formValues.password
      } as LoginData

      let model = this.createFormData(userModelToSend)
      this.loginService.login(model, 'login').subscribe(res => {
        console.log(`res`, res);
      }, err => {
        console.log(err);

        // this.toastr.error('حدث خطأ ما')
        this.toastr.error(err.error.message)
      })

    } else {
      this.listOfErrors.reverse().forEach(element => {
        this._toastr.error(element.message)
      });
    }
  }

  register() {
    this.formSubmitted = true
    this.registerFormValues = this.registerForm.value as UserData

    let registerModelToSend = {
      full_name: this.registerFormValues.full_name,
      full_name_latin: this.registerFormValues.full_name_latin,
      email: this.registerFormValues.email,
      phone: this.registerFormValues.phone, // new
      // phone: this.phone, //<---- commnted
      country_id: this.registerFormValues.country_id,
      password: this.registerFormValues.password,
      password_confirmation: this.registerFormValues.password_confirmation,
      national_id: this.registerFormValues.national_id,
      address: this.registerFormValues.address,
      residential_area: this.registerFormValues.residential_area,
      work_place: this.registerFormValues.work_place,
      job_title: this.registerFormValues.job_title,
      accept_terms_flag: this.registerFormValues.accept_terms_flag ? 1 : 0
    } as UserData

    let model = this.createFormData(registerModelToSend)

    console.log(registerModelToSend);

    if (this.validateRegisterForm()) {

      this.loginService.login(model, 'register').subscribe(res => {
        console.log(`res`, res);
        // let userModelToSend = {
        //   user_name: registerModelToSend.email,
        //   password: registerModelToSend.password
        // } as LoginData

        // let model = this.createFormData(userModelToSend)
        // this.loginService.login(model, 'login').subscribe(_ => {
        //   console.log('logged in');
        // })
        this._toastr.success('تم انشاء الحساب بنجاح');
        window.location.reload();
      }, err => {
        console.log(err);
        this.toastr.error(err.error.message)
      })

    } else {
      this.listOfErrors.reverse().forEach(element => {
        this._toastr.error(element.message)
      });
    }
  }

  showPassword() {
    this.show = !this.show
  }

  createResetPasswordForm() {
    this.resetPasswordForm = this.fb.group({
      phone: ["", [Validators.required]],
      code: ["", Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
      password_confirmation: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  get rpf() {
    return this.resetPasswordForm.controls
  }

  sendCode(type: string) {
    this.codeSent = false
    if (!this.resetPasswordForm.get('phone')?.value) {
      this.toastr.error('رقم الهاتف مطلوب')
    } else if (this.resetPasswordForm.get('phone')?.value.length != 9) {
      this.toastr.error('رقم الهاتف غير صحيح')
    } else {
      this.loginService.sendOTP(this.resetPasswordForm.get('phone')?.value, type).subscribe((message: any) => {
        this.toastr.success(message.message)
        console.log(message);
        this.codeSent = true
      }, err => {
        this.showErrors(err)
      })
    }
  }

  focusOnSecond(event: any) {
    event.target.parentElement.nextElementSibling.children[0].focus()
  }

  verifyCode(type: string) {
    let code = this.codeFirstDigit + this.codeSecondDigit + this.codeThirdDigit + this.codeFourthDigit
    this.resetPasswordForm.get('code')?.patchValue(code)

    let dataToSend = {
      phone: this.resetPasswordForm.get('phone')?.value,
      otp_code: code,
      type: type
    }

    console.log(dataToSend);

    let model = this.createFormData(dataToSend)

    this.loginService.verifyOTP(model).subscribe((res: any) => {
      this._toastr.success(res.message)
      this.codeVerified = true
      if (type == 'fast_registration'){
        Swal.fire({
          title: "تم انشاء الحساب",
          text: 'البريد الالكتروني هو رقم الهاتف الخاص بك وكلمة المرور هي 12345678',
          icon: "success"
        });
        this.isFastRegister = false
        this.isReset = false
        this.isLogin = true
      }
    }, err => {
      this.showErrors(err)
      this.codeVerified = false
    })

    // if (code == '1234') { 
    //   this.codeVerified = true 
    // } else {
    //   this.codeVerified = false
    //   this.toastr.error('رمز التحقق غير صحيح')
    // }
  }

  validateResetPasswordForm() {

    if (
      !this.resetPasswordFormValues.phone ||
      !this.resetPasswordFormValues.code ||
      !this.resetPasswordFormValues.password ||
      !this.resetPasswordFormValues.password_confirmation
    ) {
      let item = { id: 1, message: 'تأكد من جميع البيانات المطلوبة' }
      this.pushToErrorList(item)
    } else {
      this.removeFromErrorList(1)
    }

    if (this.resetPasswordFormValues.password && this.resetPasswordFormValues.password.length < 8) {
      let item = { id: 2, message: 'كلمة المرور اقل من 8 عناصر' }
      this.pushToErrorList(item)
    } else {
      this.removeFromErrorList(2)
    }

    if (this.resetPasswordFormValues.password !== this.resetPasswordFormValues.password_confirmation) {
      let item = { id: 3, message: 'كلمة المرور غير متطابقة' }
      this.pushToErrorList(item)
    } else {
      this.removeFromErrorList(3)
    }

    if (this.listOfErrors.length > 0) {
      this.formValid = false
    } else {
      this.formValid = true
    }

    return this.formValid
  }

  resetPasswordFormData(values: any) {
    let formData = new FormData();
    Object.entries(values).forEach(([key, value]: any) => {
      formData.append(key, value);
    })

    return formData
  }

  resetPassword() {
    this.formSubmitted = true
    this.resetPasswordFormValues = this.resetPasswordForm.value as ResetPassword

    let dataToSend = {
      phone: this.resetPasswordFormValues.phone,
      code: this.resetPasswordFormValues.code,
      password: this.resetPasswordFormValues.password,
      password_confirmation: this.resetPasswordFormValues.password_confirmation,
    } as ResetPassword

    let model = this.resetPasswordFormData(dataToSend)

    console.log(dataToSend);


    if (this.validateResetPasswordForm()) {

      this.loginService.resetPassword(model).subscribe((res: any) => {
        console.log(`res`, res);
        this._toastr.success(res.message);
        this.isLogin = true
        this.isReset = false
      }, err => {
        console.log(err);

        // this.toastr.error('حدث خطأ ما')
        this.toastr.error(err.error.message)
      })

    } else {
      this.listOfErrors.reverse().forEach(element => {
        this._toastr.error(element.message)
      });
    }
  }

  enableNationalId(nationalityId: number) {
    const nationalIdControl = this.registerForm.get('national_id');
    nationalIdControl?.setValue('');

    this.isEmptyNationality = true
    this.isEmptyNationality = this.nationalities && this.nationalities.length > 0 ? false : true

    if (nationalityId || !this.isEmptyNationality) {
      this.registerForm.get('national_id')?.enable()
    }
    if (this.isEmptyNationality) {
      this.registerForm.get('national_id')?.disable()
    }
  }
}
